import React from "react";

import { QuestionnaireRow } from "components/AttachmentForm/Components";
import { suggestedValueMap } from "components/AttachmentForm/constants";
import {
  NVDOptionToggler,
  DatePurchasedOptionsToggler,
  NVD_OPTIONS,
} from "components/AttachmentForm/NVDOptionToggles";
import { Input } from "components/Form/FormikControls";
import { Column } from "components/Layout";

export const G0720 = ({ formikProps }) => (
  <Column>
    <QuestionnaireRow>
      <NVDOptionToggler name="declaration.owned_since_birth" label="1." />
      {formikProps.values.declaration.owned_since_birth === NVD_OPTIONS.NO && (
        <QuestionnaireRow>
          <DatePurchasedOptionsToggler
            name="declaration.owned_since_birth_duration"
            label=""
          />
        </QuestionnaireRow>
      )}
    </QuestionnaireRow>

    <QuestionnaireRow>
      <NVDOptionToggler name="declaration.feedlot_or_treatment" label="2." />
    </QuestionnaireRow>

    <QuestionnaireRow>
      <NVDOptionToggler name="declaration.veterinary_treatment" label="3." />
    </QuestionnaireRow>

    <QuestionnaireRow>
      <NVDOptionToggler
        name="declaration.consumed_material_in_withholding_period"
        label="4."
      />
    </QuestionnaireRow>

    <QuestionnaireRow>
      <NVDOptionToggler
        name="declaration.fed_feed_containing_animal_fats"
        label="5."
      />
    </QuestionnaireRow>

    <QuestionnaireRow>
      <Input
        name="declaration.additional_information"
        label="6."
        suggestedValueFieldName={
          suggestedValueMap["declaration.additional_information"]
        }
      />
    </QuestionnaireRow>
  </Column>
);
